import Hero from "./Home/Hero";
import Offer from "./Home/Offer";
import Everybody from "./Home/Everybody";
import Testimonies from "./Home/Testimonies";
import Free from "./Home/Free";
import Wait from "./Home/Wait";
import Soon from "./Home/Soon";
function Home() {
  return (
    <>
      <Hero />
      <Offer />
      <Everybody />
      <Testimonies />
      <Free />
      <Wait />
      <Soon />
    </>
  );
}

export default Home;
